import { localeNo } from '@mobiscroll/react';

// Base Mobiscroll options
export const mobiscrollOptions = {
    locale: localeNo,
    theme: 'ios',
    themeVariant: 'light'
};

// Color palette for events
export const eventColors = [
    // Yellows & Oranges
    '#FFEB3C', // original bright yellow
    '#FFD700', // golden yellow
    '#FF9900', // original orange
    '#FF8C00', // dark orange

    // Pinks & Purples
    '#FF99FF', // original pink
    '#FF66FF', // brighter pink
    '#9C26B0', // original purple
    '#8E24AA', // similar purple
    '#3F51B5', // original indigo
    '#3949AB', // similar indigo

    // Blues & Cyans
    '#03A9F4', // bright blue

    // Greens & Teals
    '#009788', // original teal
    '#66FFCC', // original mint
    '#4CAF50', // original green
    '#4BAF4F', // similar green

    // Browns
    '#7E5D4E', // original brown
    '#795548'  // similar brown
];

// Busy color for private events
export const busyColor = '#ff0000';

// View settings for timeline
export const getViewSettings = (zoomLevel) => ({
    timeline: {
        type: 'year',
        weekNumbers: true,
        rowHeight: 'variable',
        timeCellStep: zoomLevel
    }
});

// Zoom levels configuration
export const zoomLevels = [360, 480, 720, 1440];

// Invalid resources configuration
export const invalidResources = [{
    recurring: {
        repeat: 'daily'
    },
    resource: ['100', '101', '1001'] // disable the parent resources
}, {
    resource: ['11', '1002'] // disable Rentman resources specifically
}];

// Calendar marked dates (holidays, etc.)
export const calendarMarkedDates = [
    new Date(2020, 2, 15),
    new Date(2020, 2, 22),
    {
        start: new Date(2020, 2, 23),
        end: new Date(2020, 2, 24),
        color: 'red'
    },
    {
        color: 'green',
        recurring: { repeat: 'yearly', month: 12, day: 24 }
    }
];

// Event status options
export const eventStatusOptions = [
    { value: 'busy', text: 'Busy' },
    { value: 'free', text: 'Free' },
    { value: 'tentative', text: 'Tentative' }
];

// Default event settings
export const defaultEventSettings = {
    allDay: true,
    status: 'busy',
    editable: false,
    busy: false
};
